import React, { useEffect, useState, useRef } from 'react';
import api from '../api';

const importanceColors = {
  info:   { bg: '#2563EB', light: 'rgba(37,99,235,0.15)' },
  low:    { bg: '#16a34a', light: 'rgba(22,163,74,0.15)' },
  medium: { bg: '#d97706', light: 'rgba(217,119,6,0.15)' },
  high:   { bg: '#dc2626', light: 'rgba(220,38,38,0.15)' }
};

const importanceLabels = {
  info: 'Info', low: 'Low', medium: 'Medium', high: 'Urgent'
};

export default function AlertBanner() {
  const [items, setItems]         = useState([]);
  const [index, setIndex]         = useState(0);
  const [visible, setVisible]     = useState(true);
  const [dismissed, setDismissed] = useState(false);
  const timerRef = useRef(null);
  const fadeRef  = useRef(null);

  useEffect(function() {
    Promise.all([
      api.get('/alerts?type=offer'),
      api.get('/alerts?type=travel-alert')
    ]).then(function(results) {
      var offers = results[0].data.map(function(a) {
        return { ...a, _itemType: 'offer' };
      });
      // Take only first 2 travel alerts
      var travelAlerts = results[1].data
        .sort(function(a, b) { return new Date(b.createdAt) - new Date(a.createdAt); })
        .slice(0, 2)
        .map(function(a) { return { ...a, _itemType: 'travel-alert' }; });
      setItems([...offers, ...travelAlerts]);
    }).catch(function() {});
  }, []);

  useEffect(function() {
    if (items.length < 2) return;
    timerRef.current = setInterval(function() {
      setVisible(false);
      fadeRef.current = setTimeout(function() {
        setIndex(function(i) { return (i + 1) % items.length; });
        setVisible(true);
      }, 500);
    }, 4000);
    return function() {
      clearInterval(timerRef.current);
      clearTimeout(fadeRef.current);
    };
  }, [items]);

  if (!items.length || dismissed) return null;

  var item        = items[index];
  var isTravelAlert = item._itemType === 'travel-alert';
  var importance  = item.importance || 'info';
  var colors      = importanceColors[importance] || importanceColors.info;

  // Offer banner bg stays brand clay; travel alerts use importance color
  var bannerBg = isTravelAlert ? colors.bg : 'var(--bj-clay)';

  function handleItemClick() {
    if (!isTravelAlert) return;
    var el = document.getElementById('travel-alerts-section');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function goTo(i) {
    clearInterval(timerRef.current);
    clearTimeout(fadeRef.current);
    setVisible(false);
    fadeRef.current = setTimeout(function() {
      setIndex(i);
      setVisible(true);
    }, 400);
  }

  return (
    <div style={{
      background: bannerBg,
      color: '#fff',
      transition: 'background 0.5s ease'
    }}>
      <div className="container" style={{
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 24px', gap: 16
      }}>
        {/* Content */}
        <div
          onClick={handleItemClick}
          style={{
            display: 'flex', alignItems: 'center', gap: 10, flex: 1,
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(6px)',
            transition: 'opacity 0.5s ease, transform 0.5s ease',
            cursor: isTravelAlert ? 'pointer' : 'default'
          }}
        >
          {/* Travel alert badge */}
          {isTravelAlert && (
            <span style={{
              background: 'rgba(255,255,255,0.2)',
              fontSize: '0.68rem', fontWeight: 700,
              letterSpacing: '0.08em', textTransform: 'uppercase',
              padding: '3px 9px', borderRadius: 20,
              flexShrink: 0, border: '1px solid rgba(255,255,255,0.3)'
            }}>
              {importanceLabels[importance]}
            </span>
          )}
          <span style={{ fontSize: '0.9rem' }}>
            <strong>{item.title}</strong>
          </span>
          {isTravelAlert && (
            <span style={{ fontSize: '0.82rem', opacity: 0.75, flexShrink: 0 }}>
              View alerts ↓
            </span>
          )}
        </div>

        {/* Dots + dismiss */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          {items.length > 1 && (
            <div style={{ display: 'flex', gap: 6 }}>
              {items.map(function(a, i) {
                return (
                  <button
                    key={a._id}
                    onClick={function() { goTo(i); }}
                    style={{
                      width: i === index ? 22 : 7, height: 7,
                      borderRadius: 4, border: 'none', padding: 0,
                      cursor: 'pointer',
                      background: i === index ? '#fff' : 'rgba(255,255,255,0.4)',
                      transition: 'width 0.35s ease, background 0.35s ease'
                    }}
                  />
                );
              })}
            </div>
          )}
          <button
            onClick={function() { setDismissed(true); }}
            style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: '1rem', opacity: 0.8 }}
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}